import authStore from "../modules/auth/AuthModel";

export const hasPermission = (code: string) => {
  const permissions = authStore.permissions;
  return permissions.includes(code);
};
